<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container>
      <a-form :form="form" slot="detail">
        <a-row>
          <a-col :span="12">
            <!--label="养户编码"-->
            <a-form-item :label="$t('label.farmerCode')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input :disabled='isCodeDisabled' v-decorator="['code', validatorRules.code]" :placeholder="$t('label.pleaseEnterTheFarmerCode')"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <!--label="养户名称"-->
            <a-form-item :label="$t('label.farmerName')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <!-- <a-input v-decorator="['name', validatorRules.name]" placeholder="请输入养户名称"></a-input> -->
              <mtc-lang-popover :whetherLang="whetherLang('name')" :popLists="getMainTablePop('name')">
                <a-input
                  v-decorator="['name', validatorRules.name]"
                  :read-only="whetherLang('name')"
                  @click="isLangClick('name', true)"
                  :placeholder="$t('label.pleaseEnterTheFarmerName')"
                ></a-input>
              </mtc-lang-popover>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <!--label="养户类型"-->
            <a-form-item :label="$t('label.farmerType')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag type="list" v-decorator="['farmerType',validatorRules.farmerType]" :trigger-change="true" dictCode="yhlx" :placeholder="$t('label.pleaseSelectTheTypeOfFarmer')"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <!--label="身份证号"-->
            <a-form-item :label="$t('label.idNumber')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['idCode',validatorRules.idCode]" :placeholder="$t('label.pleaseEnterTheIdCardNumber')"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <!--label="所属公司"-->
            <a-form-item :label="$t('label.affiliatedCompany')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag type="list" v-decorator="['companyCode',{'initialValue': initCompanyCode, rules: validatorRules.companyCode.rules}]" :trigger-change="true" dictCode="sys_depart,depart_name,org_code,org_category='1' and del_flag='0'" :placeholder="$t('label.pleaseSelectaffiliatedCompany')"/>
            </a-form-item>
          </a-col>
<!--          <a-col :span="12">-->
<!--            <a-form-item label="所属片区" :labelCol="labelCol" :wrapperCol="wrapperCol">-->
<!--              <j-dict-select-tag type="list" v-decorator="['adminArea']" :trigger-change="true" dictCode="efs_md_archives,name,code,arch_type='100'" placeholder="请选择所属片区"/>-->
<!--            </a-form-item>-->
<!--          </a-col>-->
          <a-col :span="12">
            <!--label="所属技术员工号"-->
            <a-form-item :label="$t('label.affiliatedTechnicalStaffNumber')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag type="list" v-decorator="['managerCode']" :trigger-change="true" dictCode="sys_user,realname,username" :placeholder="$t('label.pleaseSelectaffiliatedTechnicalStaffNumber')"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <!--label="是否个体户"-->
            <a-form-item :label="$t('label.whetherSelfEmployed')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag type="list" v-decorator="['isSelfEmployed']" :trigger-change="true" dictCode="is_gth" :placeholder="$t('label.pleaseSelectWhetherSelfEmployed')"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <!--label="是否企业"-->
            <a-form-item :label="$t('label.whetherEnterprise')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag type="list" v-decorator="['isEnterprise',validatorRules.isEnterprise]" :trigger-change="true" dictCode="is_qy" :placeholder="$t('label.pleaseSelectWhetherEnterprise')"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <!--label="养户状态"-->
            <a-form-item :label="$t('label.growerStatus')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag  type="list" v-decorator="['farmerStatus',validatorRules.farmerStatus]" :trigger-change="true" dictCode="yhzt" :placeholder="$t('label.pleaseSelectGrowerStatus')"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <!--label="状态改变时间"-->
            <a-form-item :label="$t('label.statusChangeTime')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-date :placeholder="$t('label.pleaseSelectTheTimeOfStatusChange')" v-decorator="['validModifyTime']" :trigger-change="true" style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <!--label="距公司公里数"-->
            <a-form-item :label="$t('label.distanceToCompany')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['farFromCompany']" :placeholder="$t('label.pleaseEnterTheNumberOfKilometersFromTheCompany')" style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :xs="24" :sm="12">
            <!--label="国家"-->
            <a-form-item :label="$t('label.country')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag v-decorator="['countryCode',validatorRules.countryCode]" :trigger-change="true"
                                 @change="handleCountryDesc"
                                 dictCode="sys_category,name,code,code='4'"/>
<!--              <a-input v-decorator="['countryCode']" placeholder="请输入国家编码"></a-input>-->
            </a-form-item>
          </a-col>
          <a-col :xs="24" :sm="12">
            <!--label="省份"-->
            <a-form-item :label="$t('label.province')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag v-decorator="['provinceCode',validatorRules.provinceCode]"
                                 :triggerChange="true" @change="handleProvinceDesc" :dictCode="dictProvinceCode"/>
<!--              <a-input v-decorator="['provinceCode']" placeholder="请输入省份编码"></a-input>-->
            </a-form-item>
          </a-col>
          <a-col :xs="24" :sm="12">
           <!-- label="市/地级市"-->
            <a-form-item :label="$t('label.province')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag  v-decorator="['cityCode',validatorRules.cityCode]"
                                 :triggerChange="true" @change="handleCityDesc" :dictCode="dictCityCode"/>

<!--              <a-input v-decorator="['cityCode']" placeholder="请输入市/地级市编码"></a-input>-->
            </a-form-item>
          </a-col>
          <a-col :xs="24" :sm="12">
            <!--label="县/区"-->
            <a-form-item :label="$t('label.county')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag  v-decorator="['countyCode',validatorRules.countyCode]"
                                 :triggerChange="true" :dictCode="dictCountyCode"/>

<!--              <a-input v-decorator="['countyCode']" placeholder="请输入县/区编码"></a-input>-->
            </a-form-item>
          </a-col>
          <a-col :xs="24" :sm="12">
            <!--label="乡镇/街道/社区"-->
            <a-form-item  :label="$t('label.street')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <!-- <a-input v-decorator="['townCode']" placeholder="请输入乡镇/街道/社区"></a-input> -->
              <mtc-lang-popover :whetherLang="whetherLang('townCode')" :popLists="getMainTablePop('townCode')">
                <a-input
                  v-decorator="['townCode']"
                  :read-only="whetherLang('townCode')"
                  @click="isLangClick('townCode', false)"
                  :placeholder="$t('label.pleaseEnterTheStreet')"
                ></a-input>
              </mtc-lang-popover>

            </a-form-item>
          </a-col>
          <a-col :xs="24" :sm="12">
            <!--label="地址(街道门牌号)"-->
            <a-form-item :label="$t('label.address')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <!-- <a-input v-decorator="['address']" placeholder="请输入地址(街道门牌号)"></a-input> -->
               <mtc-lang-popover :whetherLang="whetherLang('address')" :popLists="getMainTablePop('address')">
                <a-input
                  v-decorator="['address']"
                  :read-only="whetherLang('address')"
                  @click="isLangClick('address', false)"
                  :placeholder="$t('label.pleaseEnterTheAddress')"
                ></a-input>
              </mtc-lang-popover>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <!--label="电话"-->
            <a-form-item  :label="$t('label.telephone')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['telephone']" :placeholder="$t('label.pleaseEnterYourPhoneNumber')" style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <!--label="配偶姓名"-->
            <a-form-item :label="$t('label.spouseName')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <!-- <a-input v-decorator="['spouseName']" placeholder="请输入配偶姓名"></a-input> -->
               <mtc-lang-popover :whetherLang="whetherLang('spouseName')" :popLists="getMainTablePop('spouseName')">
                <a-input
                  v-decorator="['spouseName']"
                  :read-only="whetherLang('spouseName')"
                  @click="isLangClick('spouseName', false)"
                  :placeholder="$t('label.pleaseEnterYourSpouseName')"
                ></a-input>
               </mtc-lang-popover>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <!--label="配偶手机"-->
            <a-form-item :label="$t('label.spouseCellPhone')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['spouseMobile', validatorRules.spouseMobile]" :placeholder="$t('label.pleaseEnterYourSpouseCellPhone')"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <!--label="配偶身份证号"-->
            <a-form-item  :label="$t('label.spouseIDNumber')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['spouseIdCode', validatorRules.spouseIdCode]" :placeholder="$t('label.pleaseEnterYourSpouseIDNumber')"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <!--label="家庭地址"-->
            <a-form-item :label="$t('label.homeAddress')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <!-- <a-input v-decorator="['homeAddr']" placeholder="请输入家庭地址"></a-input> -->
              <mtc-lang-popover :whetherLang="whetherLang('homeAddr')" :popLists="getMainTablePop('homeAddr')">
                <a-input
                  v-decorator="['homeAddr']"
                  :read-only="whetherLang('homeAddr')"
                  @click="isLangClick('homeAddr', false)"
                  :placeholder="$t('label.pleaseEnterYourHomeAddress')"
                ></a-input>
               </mtc-lang-popover>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <!--label="开户银行"-->
            <a-form-item :label="$t('label.bankAccount')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <!-- <a-input v-decorator="['bankName']" placeholder="请输入开户银行"></a-input> -->
               <mtc-lang-popover :whetherLang="whetherLang('bankName')" :popLists="getMainTablePop('bankName')">
                <a-input
                  v-decorator="['bankName']"
                  :read-only="whetherLang('bankName')"
                  @click="isLangClick('bankName', false)"
                  :placeholder="$t('label.pleaseInputTheBankAccount')"
                ></a-input>
               </mtc-lang-popover>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <!--label="开户行地址"-->
            <a-form-item :label="$t('label.bankAddress')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <!-- <a-input v-decorator="['bankAddress']" placeholder="请输入开户行地址"></a-input> -->
              <mtc-lang-popover :whetherLang="whetherLang('bankAddress')" :popLists="getMainTablePop('bankAddress')">
                <a-input
                  v-decorator="['bankAddress']"
                  :read-only="whetherLang('bankAddress')"
                  @click="isLangClick('bankAddress', false)"
                  :placeholder="$t('label.pleaseEnterTheBankAddress')"
                ></a-input>
               </mtc-lang-popover>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <!--label="银行卡号"-->
            <a-form-item :label="$t('label.bankCardNumber')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['accountNo']" :placeholder="$t('label.pleaseInputTheBankCardNumber')"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <!--label="是否有效"-->
            <a-form-item :label="$t('label.validOrNot')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag type="list" v-decorator="['validFlag',{'initialValue': 'Y'}]" :trigger-change="true" dictCode="sfyx" :placeholder="$t('label.pleaseChooseWhetherItIsValidOrNot')"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <!--:label="$t('label.remarks')"-->
            <a-form-item :label="$t('label.remarks')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <!-- <a-textarea v-decorator="['notes']" rows="4" placeholder="请输入备注"/> -->
              <mtc-lang-popover :whetherLang="whetherLang('notes')" :popLists="getMainTablePop('notes')">
                <a-textarea
                  v-decorator="['notes']"
                  :read-only="whetherLang('notes')"
                  @click="isLangClick('notes', false)"
                  :placeholder="$t('label.pleaseEnterANote')"
                ></a-textarea>
              </mtc-lang-popover>
            </a-form-item>
          </a-col>
          <a-col v-if="showFlowSubmitButton" :span="24" style="text-align: center">
            <a-button @click="handleOk">{{$t('button.submit')}}</a-button>
          </a-col>
        </a-row>
      </a-form>

    </j-form-container>
    <mtc-lang-modal/>
  </a-spin>
</template>

<script>

  import { httpAction, getAction } from '@/api/manage'
  import pick from 'lodash.pick'
  import { validateDuplicateValue } from '@/utils/util'
  import JFormContainer from '@/components/jeecg/JFormContainer'
  import JDate from '@/components/jeecg/JDate'
  import JDictSelectTag from "@/components/dict/JDictSelectTag"
  import { getCurrentUser } from '@api/api'
  import { mtcLangModalMixin } from '@/mixins/mtcLangModalMixin'

  export default {
    name: 'EfsMdFarmerForm',
    mixins: [mtcLangModalMixin],
    components: {
      JFormContainer,
      JDate,
      JDictSelectTag,
    },
    props: {
      //流程表单data
      formData: {
        type: Object,
        default: ()=>{},
        required: false
      },
      //表单模式：true流程表单 false普通表单
      formBpm: {
        type: Boolean,
        default: false,
        required: false
      },
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        mainTable: 'efs_md_farmer',
        isCodeDisabled: false,
        // form: this.$form.createForm(this),
        model: {},
        dictProvinceCode:null,
        dictCountyCode:null,
        dictCityCode:null,
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        validatorRules: {
          code: {
            rules: [
              { required: true, message: this.$t('label.pleaseEnterTheFarmerCode')},
              { validator: (rule, value, callback) => validateDuplicateValue('efs_md_farmer', 'code', value, this.model.id, callback)},
            ]
          },
          name: {
            rules: [
              { required: true, message: this.$t('label.pleaseEnterTheFarmerName')},
            ]
          },
          farmerStatus: {
            rules: [
              { required: true, message: this.$t('label.pleaseSelectGrowerStatus')},
              { validator: (rule, value, callback) => validateDuplicateValue('efs_md_farmer', 'code', value, this.model.id, callback)},
            ]
          },
          isEnterprise: {
            rules: [
              { required: true, message: this.$t('label.pleaseSelectWhetherEnterprise')},
            ]
          },
          idCode: {
            rules: [
              { required: true, message: this.$t('label.pleaseEnterTheIdCardNumber')},
              {pattern:/(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/, message: this.$t('label.pleaseEnterTheIdCardNumber')},
            ]
          },
            spouseIdCode:{
                rules: [
                    {pattern:/(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/, message: this.$t('label.pleaseEnterYourSpouseIDNumber')},
                ]
            },
          companyCode: {
            rules: [
              { required: true, message: this.$t('label.pleaseSelectaffiliatedCompany')},
            ]
          },
          farmerType: {
            rules: [
              { required: true, message: this.$t('label.pleaseSelectTheTypeOfFarmer')},
            ]
          },
          spouseMobile: {
            rules: [
              { required: false},
              { pattern: /^1[3456789]\d{9}$/, message: this.$t('label.pleaseEnterYourSpouseCellPhone')},
            ]
          },
          validModifyTimeShow:new Date(),
        },
        url: {
          add: "/farmerArchive/efsMdFarmer/add",
          edit: "/farmerArchive/efsMdFarmer/edit",
          queryById: "/farmerArchive/efsMdFarmer/queryById"
        },
        initCompanyCode: null,
      }
    },
    computed: {
      formDisabled(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return false
          }
          return true
        }
        return this.disabled
      },
      showFlowSubmitButton(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return true
          }
        }
        return false
      }
    },
    created () {
      //如果是流程中表单，则需要加载流程表单data
      this.showFlowData();
      getCurrentUser().then((res) => {
        if (res.success) {
          this.initCompanyCode = res.result.orgCode;
        }
      });
    },
    methods: {
      add () {
        this.edit({});
      },
      edit (record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
        if (this.model.id) {
          this.isCodeDisabled = true;
        }else{
          this.isCodeDisabled = false;
        }
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'code','name','farmerType','idCode','companyCode','managerCode','isSelfEmployed','isEnterprise','farmerStatus','validModifyTime','farFromCompany','telephone','spouseName','spouseMobile','spouseIdCode','homeAddr','bankName','bankAddress','accountNo','validFlag','notes','countryCode', 'provinceCode', 'cityCode', 'countyCode', 'townCode', 'address'))
        })
      },
      handleCountryDesc(value, row) {
        console.log(value, row)
        this.countryDesc = value
        // this.queryParam.breedClassCode = value
        this.dictProvinceCode = 'sys_category,name,code,pid=(select id from sys_category where code= \'' + value + '\')'
      },
      handleProvinceDesc(value) {
        this.provinceDesc = value
        this.dictCityCode = 'sys_category,name,code,pid=(select id from sys_category where code= \'' + value + '\')'
      },
      handleCityDesc(value) {
        this.cityDesc = value
        this.dictCountyCode = 'sys_category,name,code,pid=(select id from sys_category where code= \'' + value + '\')'
      },
      //渲染流程表单数据
      showFlowData(){
        if(this.formBpm === true){
          let params = {id:this.formData.dataId};
          getAction(this.url.queryById,params).then((res)=>{
            if(res.success){
              this.edit (res.result);
            }
          });
        }
      },
      // submitForm () {
      //   const that = this;
      //   // 触发表单验证
      //   this.form.validateFields((err, values) => {
      //     if (!err) {
      //       that.confirmLoading = true;
      //       let httpurl = '';
      //       let method = '';
      //       if(!this.model.id){
      //         httpurl+=this.url.add;
      //         method = 'post';
      //       }else{
      //         httpurl+=this.url.edit;
      //          method = 'put';
      //       }
      //       let formData = Object.assign(this.model, values);
      //       console.log("表单提交数据",formData)
      //       httpAction(httpurl,formData,method).then((res)=>{
      //         if(res.success){
      //           that.$message.success(res.message);
      //           that.$emit('ok');
      //         }else{
      //           that.$message.warning(res.message);
      //         }
      //       }).finally(() => {
      //         that.confirmLoading = false;
      //       })
      //     }

      //   })
      // },
      popupCallback(row){
        this.form.setFieldsValue(pick(row,'code','name','farmerType','idCode','companyCode','managerCode','isSelfEmployed','isEnterprise','farmerStatus','validModifyTime','farFromCompany','telephone','spouseName','spouseMobile','spouseIdCode','homeAddr','bankName','bankAddress','accountNo','validFlag','notes','countryCode', 'provinceCode', 'cityCode', 'countyCode', 'townCode', 'address' ))
      },
      validModifyTimeChange(e){
        if(e.target.value === '1'){
          this.validModifyTimeShow = new Date();
        }else {
          this.validModifyTimeShow = new Date();
        }
      },
    }
  }
</script>